const styles = (theme) => ({
  root: {
    '& .GridItemLeft': {
      [theme.breakpoints.down('xs')]: {
        flexGrow: '1',
        maxWidth: '100%',
        flexBasis: '100%',
      },
    },
    '& .GridItemRight': {
      [theme.breakpoints.down('xs')]: {
        flexGrow: '1',
        maxWidth: '100%',
        flexBasis: '100%',
        textAlign: 'left',
        '& p': {
          margin: `${theme.spacing.unit}px 0 0`,
        },
        '& button': {
          padding: 0,
        },
      },
    },
  },
  title: {
    marginLeft: '-5px',
  },
  negativeTopMargin: {
    // Use negative margin to counter-act the displacement caused by the avatar
    [theme.breakpoints.up('md')]: {
      marginTop: '-30px',
    },
  },
  appointmentCard: {
    borderColor: theme.palette.custom.details,
    borderWidth: '3px',
    borderRadius: 0,
  },
  cardHeader: {
    alignItems: 'flex-start',
    [theme.breakpoints.up('md')]: {
      paddingBottom: 0,
    },
  },
  viewMoreLinkWrapper: {
    marginTop: theme.spacing.unit * 2,
    [theme.breakpoints.up('sm')]: {
      marginTop: 0,
    },
  },
  cardContent: {
    padding: `0 ${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${
      theme.spacing.unit * 2
    }px`,
    [theme.breakpoints.up('md')]: {
      padding: `0 ${theme.spacing.unit * 6}px ${theme.spacing.unit * 3}px ${
        theme.spacing.unit * 19.75
      }px`,
    },
  },
  cardTitleLarge: {
    '&&': {
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.125rem',
      },
    },
  },
  details: {},
  subtitle: {
    marginTop: theme.spacing.unit * 2,
  },
  avatar: {
    background: theme.palette.background.lighter,
    color: theme.palette.text.white,
    marginTop: -theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit / 2,
    border: 'none',
    width: 70,
    height: 80,
    marginTop: '10px',
    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
    },
  },
  calendarTop: {
    height: 20,
    background: theme.palette.custom.details,
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    flexDirection: 'column',
    borderRadius: '3px 3px 0 0',
    borderColor: theme.palette.custom.details,
    borderStyle: 'solid',
    borderWidth: '2px',
    [theme.breakpoints.up('md')]: {
      height: 20,
    },
  },
  calendarBottom: {
    height: 60,
    borderRadius: '0 0 3px 3px',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: theme.palette.border.lighter,
  },
  dayName: {
    color: theme.palette.text.white,
    textAlign: 'center',
    fontSize: '0.875rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '0.875rem',
    },
  },
  day: {
    textAlign: 'center',
    fontSize: '1.625rem',
    fontWeight: 600,
    padding: 0,
    [theme.breakpoints.up('md')]: {
      fontSize: '1.625rem',
    },
  },
  monthYear: {
    textAlign: 'center',
    textTransform: 'uppercase',
    fontSize: '0.875rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '0.875rem',
    },
  },
});

export default styles;
